import { SecureAction } from '../secure-actions';

export class MlpSecureAction extends SecureAction {
  public static readonly NAVIGATE: SecureAction = new MlpSecureAction('admin:mlp');

  // mlp
  public static readonly VIEW_ADMIN_MLP: SecureAction = new MlpSecureAction('admin:mlp:mlp|view');

  private constructor(name: string) {
    super(name);
  }
}
